"use strict";
exports.__esModule = true;
exports.defineCardRescheduleRange = void 0;
var SUNDAY_WEEKDAY_INDEX = 7;
var getFirstAvailableDay = function (firstChargeDate, today) {
    var initialDay = firstChargeDate.day > today.day
        ? firstChargeDate.set({ day: firstChargeDate.day + 1 })
        : today.set({ day: today.day + 1 });
    var isInitialDaySunday = initialDay.weekday === SUNDAY_WEEKDAY_INDEX;
    return isInitialDaySunday ? initialDay.day + 1 : initialDay.day;
};
var defineCardRescheduleRange = function (rescheduleRangeLastDay, firstChargeDate, today) {
    var firstAvailableDay = getFirstAvailableDay(firstChargeDate, today);
    var currentDay = today.set({ day: firstAvailableDay });
    var rangeDays = [];
    while (currentDay.day <= rescheduleRangeLastDay) {
        var isSunday = currentDay.weekday === SUNDAY_WEEKDAY_INDEX;
        if (!isSunday) {
            rangeDays.push(currentDay.day);
        }
        currentDay = currentDay.set({ day: currentDay.day + 1 });
    }
    return rangeDays;
};
exports.defineCardRescheduleRange = defineCardRescheduleRange;
